var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_12923",
    width: 43.588,
    height: 28.959,
    viewBox: "0 0 43.588 28.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11092",
    transform: "translate(6.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11086",
    transform: "translate(14.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25684",
    d: "M401.041 119.234v-7.874H387.48v7.874zm-3.062-5.249h.874v3.5h-.874zm0 0",
    className: "cls-1",
    transform: "translate(-387.48 -111.36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11087",
    transform: "translate(14.915 8.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25685",
    d: "M387.48 120.718v19.247h13.561v-19.247zm11.373 5.25h-.874v-3.937h.874zm0 0",
    className: "cls-1",
    transform: "translate(-387.48 -120.718)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11091",
    transform: "translate(0 13.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25686",
    d: "M384.294 126h-11.225a1.544 1.544 0 0 0-1.542 1.542v2.05h14.308v-2.05a1.543 1.543 0 0 0-1.541-1.542zm-9.357 2.092a.419.419 0 0 1-.593-.593.42.42 0 0 1 .593 0 .418.418 0 0 1 0 .593zm2.694 0a.42.42 0 1 1 .122-.3.422.422 0 0 1-.122.3zm2.694 0a.417.417 0 1 1 .123-.3.42.42 0 0 1-.123.3zm2.694 0a.424.424 0 0 1-.3.123.419.419 0 0 1 0-.839.419.419 0 0 1 .3.715zm0 0",
    className: "cls-1",
    transform: "translate(-371.527 -126.001)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11089",
    transform: "translate(2.635 6.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25687",
    d: "M383.385 133.109h-9.04v5.448h9.04zm-1.377 1.8h-6.286a.419.419 0 1 1 0-.838h6.286a.419.419 0 0 1 0 .838zm0 0",
    className: "cls-1",
    transform: "translate(-374.345 -133.109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11090",
    transform: "translate(0 4.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25688",
    d: "M371.527 139.076a1.543 1.543 0 0 0 1.542 1.542h11.225a1.543 1.543 0 0 0 1.542-1.542v-8.336h-14.309zm1.8-6.54a.419.419 0 0 1 .42-.419h9.878a.418.418 0 0 1 .419.419v6.286a.419.419 0 0 1-.419.42h-9.878a.42.42 0 0 1-.42-.42zm0 0",
    className: "cls-1",
    transform: "translate(-371.527 -130.74)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_81",
    transform: "translate(0 28.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25689",
    d: "M407.165 142.27h-42.654a.467.467 0 0 1 0-.935h42.654a.467.467 0 0 1 0 .935z",
    className: "cls-1",
    transform: "translate(-364.044 -141.335)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsWhite);
export default __webpack_public_path__ + "static/media/assets-white.79765b26434ceca094a8994b2e15ba60.svg";
export { ForwardRef as ReactComponent };